import { ItemTypes } from '../Constants'
import Format from 'date-fns/format';
import ParseISO from 'date-fns/parseISO';

export const deepCopy = (object) => JSON.parse(JSON.stringify(object));

export const paramsToObject = (queryString) => {
    const splitArray = queryString.split('?')
    const object = splitArray[1] && splitArray[1].split('&').reduce((finalSet, pair) => {
        const pairAsArray = pair.split('=');
        finalSet[pairAsArray[0]] = pairAsArray[1]
        return finalSet;
    }, {}) || {}

    return object
}

export const createItemUrl = (itemId, itemType) => {
    let invalidParams = false;
    if (!itemId) {
        console.warn('createItemUrl -> itemId prop is required!');
        invalidParams = true;
    }
    if (!itemType) {
        console.warn('createItemUrl -> itemType prop is required!')
        invalidParams = true;
    }
    if (invalidParams) return;
    switch (itemType) {
        case ItemTypes.product:
            return `/single-product?id=${itemId}`
        case ItemTypes.recipe:
            return `/single-recipe?id=${itemId}`
        case ItemTypes.event:
            return `/single-event?id=${itemId}`
        default:
            console.warn('createItemUrl -> itemType prop is not one of: ', ItemTypes)
            return undefined;
    }
}

export const convertIsoToFormat = (IsoString, format = 'MMMM do, yyyy, h:mm a') => {
    let splitDatetime = IsoString.split('.');
    splitDatetime.splice(splitDatetime.length - 1, 1);
    splitDatetime.join('');
    const parsedFromISO = ParseISO(splitDatetime[0]);
    const dateObject = new Date(parsedFromISO);
    const formattedDate = Format(dateObject, format);

    console.log("IsoString: ", IsoString);
    console.log("parsedFromIso: ", parsedFromISO);
    console.log("dateObject: ", dateObject);
    return formattedDate;
}
